export enum PositioningStrategy {
    Absolute = 'absolute',
    Fixed = 'fixed',
}

export interface MaxSizeChangeProps {
    maxWidth?: number;
    maxHeight?: number;
}
